import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { init } from "@noriginmedia/norigin-spatial-navigation";
import { Menu } from "./sidebar";
import ContentLoader from "../common/ContentLoader";
import ClearCacheButton from "../common/ClearCacheButton";

const GlobalStyle = createGlobalStyle`
  ::-webkit-scrollbar {
    display: none;
  }
`;

const AppContainer = styled.div`
  background: #121212;
  width: 100vw;
  height: 100vh;
  display: table;
  table-layout: fixed;
  direction: rtl;
`;

const SidebarCell = styled.div`
  display: table-cell;
  width: 250px;
  min-width: 250px;
  max-width: 250px;
  vertical-align: top;
  height: 100vh;
`;

/**
 * ContentCell provides the table-cell container.
 * Scroll is handled by each content page's internal ScrollingRows component.
 * overflow: hidden prevents double scroll bars.
 */
const ContentCell = styled.div`
  display: table-cell;
  width: calc(100vw - 250px);
  vertical-align: top;
  height: 100vh;
  overflow: visible;
`;

/**
 * PageLayout - A layout component that keeps the sidebar visible during loading
 * 
 * This component wraps pages that use the sidebar layout.
 * During loading states:
 * - The sidebar remains visible but navigation is disabled
 * - The content area shows a skeleton or loading indicator
 * 
 * @param {boolean} loading - Local loading state for this page
 * @param {React.ReactNode} children - The page content to render
 * @param {string} focusKey - Optional focus key for spatial navigation
 * @param {string} skeletonType - Type of skeleton: 'home', 'detail', 'search', 'profile', or null for spinner
 */
export default function PageLayout({
  children,
  loading = false,
  focusKey = "MENU",
  skeletonType = null
}) {
  // Initialize spatial navigation
  React.useEffect(() => {
    init({
      debug: false,
      visualDebug: false,
      rtl: true,
    });
  }, []);

  return (
    <AppContainer>
      <GlobalStyle />
      <ClearCacheButton />
      <SidebarCell>
        <Menu focusKey={focusKey} />
      </SidebarCell>
      <ContentCell>
        <ContentLoader localLoading={loading} skeletonType={skeletonType}>
          {children}
        </ContentLoader>
      </ContentCell>
    </AppContainer>
  );
}


